<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">포장상품 입고관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>포장상품명</p>
                <input type="text" placeholder="포장상품명을 입력하세요" class="form_control" v-model="searchInfo.wrapperName">
              </li>
              <li>
                <p>포장종류</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.wrapperClass" >
                    <b-form-select-option value="">전체</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in wrapperClassList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
            </div>
            <table class="list no_view">
              <thead>
                <tr>
                    <th>입고일자</th>
                    <th>포장상품명</th>
                    <th>포장종류</th>
                    <th>입고량</th>
                    <th>사용량</th>
					          <th>관리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="wrapperWrhsList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in wrapperWrhsList" :key="index">
                  <td><span>{{ item.wrapper_expr_dt }}</span></td>
                  <td class="al"><span>{{ item.wrapper_nm }}</span></td>
                  <td><span>{{ item.wrapper_class_nm }}</span></td>
                  <td><span>{{ item.wrapper_wrhs_qnty }}</span></td>
                  <td><span>{{ item.wrapper_use_qnty }}</span></td>
                  <td>
                    <div class="form_inline" v-if="item.wrapper_use_qnty == 0">
                      <button class="icon icon_del" @click="fn_delete(item.wrapper_wrhs_cd)"></button>
                      <button class="icon icon_edit" @click="fn_move_dtl_page(item.wrapper_wrhs_cd)"></button>
                    </div>
                    <span v-else>수정불가</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Pagination from "@/components/AdminPagination.vue"

    export default {
        name: 'WrapperWrhsMngt',
        components: {
            Pagination,
        },
        mixins: [commonUtil],
        data() {
        return {
                searchInfo : {
                    wrapperName : '',
                    wrapperClass : '',
                    pageInfo : {
                        page : 1,
                        pageSize : 10,
                        totPage : 0
                    }              
                },
                pagingShow : false,
                wrapperClassList : [],
                wrapperWrhsList: [],
                selected: null
            }
        },
        async created(){
            //공통코드 - 포장종류
            this.wrapperClassList = await this.getCode('GC00000005');         
            console.log("@@@@ wrapperClassList : %o",this.wrapperClassList);
            

            let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
            if(searchInfoStore != null && searchInfoStore != {}){
                this.searchInfo = searchInfoStore
            }
            
            
            this.fn_search();
        },
        methods : {
            fn_search(){
                console.log("@@@ search : ",this.searchInfo);

                this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

                axios
                    .post("/api/admin/wrapperWrhs/getWrapperWrhs", this.searchInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.wrapperWrhsList = res.data.wrapperWrhsInfo;

                        console.log("@@@@ wrapperList : %o",this.wrapperWrhsList);

                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchInfo.pageInfo.totPage> 0){
                            this.pagingShow = true;                          
                        }                        

                    })
                    .catch((err) => console.log(err));
            },
            fn_move_reg_page(){
                //this.$store.dispatch('wrapper/setWrapperCd', '');
                this.$router.push("/admin/wrapper/WrapperWrhsMngtReg");
            },
            fn_move_dtl_page(wrapperWrhsCd){
                this.$store.dispatch('commonStore/setMainCode', wrapperWrhsCd);
                this.$store.dispatch('commonStore/setStatus', 'M');                                 
                this.$router.push("/admin/wrapper/WrapperWrhsMngtReg");			
            },
            fn_delete(wrapperWrhsCd){
                
                let param = new Object();
                param.wrapperWrhsCd = wrapperWrhsCd;

                axios
                    .post("/api/admin/wrapperWrhs/deleteWrapperWrhs", param)
                    .then((res) => {
                        alert("삭제되었습니다");
                        this.fn_search();
                    })
                    .catch((err) => console.log(err));
            }
        }
        
    }
</script>